import classNames from '@/utils/classNames';
import type { FCl } from 'react-fc';
import styles from './Loading.module.css';

/**
 * A loader to be used to indicate something is occurring.
 */
export const Loading: FCl<IProps> = ({ className, size = Size.Large }) => {
    const dotClass = classNames(styles.LoaderDot, size === Size.Small && styles.LoaderDotSmall);
    return (
        <div className={classNames(styles.Wrap, className)}>
            <span className={dotClass} />
            <span className={dotClass} />
            <span className={dotClass} />
        </div>
    );
};

export enum Size {
    Large,
    Small,
}

interface IProps {
    size?: Size;
}

/**
 * A loader shaped like a small bar chart, for chart areas that are still fetching data.
 * Sits centred in the empty panel with a "Loading" label beneath it.
 */
export const LoadingChart: FCl = ({ className }) => (
    <div className={classNames(styles.ChartWrap, className)} role="status">
        <div className={styles.Axes} aria-hidden>
            {Array.from({ length: 4 }).map((_, i) => (
                <span key={i} className={styles.ChartBar} />
            ))}
        </div>
        <p>Building chart…</p>
    </div>
);
